import $ from "jquery";
import Vars from "../../vars";
import Action from "../classes/Action";
import Validation from "../classes/Validation";
import Request from "../../components/request";
import Modal from "../../components/Modal";
import Utils from "../../components/utils";

class Tariff {
    constructor(args) {
        let self = this;

        self._setArgs(args);
        self._init();
    }

    _elems = {
        $content : $(),
        $modal   : $(),
        $form    : $(),
        $connect : $()
    };

    _const = {
        entities : 'tariffs',
        entity   : 'tariff',
        id       : 'id'
    };

    _args = {
        page  : '',
        title : '',
        id    : 0
    };

    _utils = {
        validation : {}
    };

    _state = {
        items    : {},
        item     : {}
    };

    _setArgs = (args) => {
        let self = this;

        self._args.page  = args.page;
        self._args.title = args.title || self._args.title;
        self._args.id    = args.id    || self._args.id;
    };

    _setValidation = () => {
        let self = this;

        if (!self._elems.$form.length) return;

        self._utils.validation = new Validation({
            form : self._elems.$form
        });
    };

    _initModal = () => {
        let self = this;

        let items = self._state.items.filter(function(item){
            return item.id == self._state.id;
        });
        if (!items.length) return;

        self._state.item = items[0];

        let options = '';
        if (self._state.item.options) {
            if ('widgets' in self._state.item.options && self._state.item.name in self._state.item.options.widgets) {
                options += '<p>Виджеты: ' + self._state.item.options.widgets[self._state.item.name] +  '</p>';
            }
            if ('feeds' in self._state.item.options && self._state.item.name in self._state.item.options.feeds) {
                options += '<p>XML-фиды: ' + self._state.item.options.feeds[self._state.item.name] +  '</p>';
            }
            if ('socials' in self._state.item.options && self._state.item.name in self._state.item.options.socials && self._state.item.options.socials[self._state.item.name]) {
                options += '<p>Выгрузка ВКонтакте: ' + self._state.item.options.socials[self._state.item.name] +  '</p>';
            }
            if ('crms' in self._state.item.options && self._state.item.name in self._state.item.options.crms && self._state.item.options.crms[self._state.item.name]) {
                options += '<p>Интеграция с CRM: ' + self._state.item.options.crms[self._state.item.name] +  '</p>';
            }
        }

        let fields = {
            package : {
                title      : 'Период',
                type       : 'select',
                id         : 'id',
                name       : 'display_name',
                required   : true,
                value      : null,
                options    : self._state.item.packages,
                additional : '<p>Стоимость пакета: <span class="price"></span></p>'
            },
            desсription : {
                title : 'Включает',
                type  : 'description',
                value : options
            }
        };

        self._elems.$modal = new Modal({
            title   : 'Подключить тарифный план "' + self._state.item.display_name + '"',
            content : Utils.renderProfileTemplate('form', {
                item   : self._state.item,
                entity : self._const.entity,
                fields : fields,
                buttons : {
                    one : {
                        class : 'confirm button--edit',
                        title : 'Подключить',
                        type  : 'submit'
                    },
                    two : null
                }
            }),
            closingConfirmation: true,
            confirm : function(args) {
                self._bindConfirm(args);
            }
        });

        self._elems.$form = self._elems.$modal.find('form');
        if (!self._elems.$form.length) return;

        self._setValidation();

        self._elems.$form.find('[name="tariff[package]"]').change(function(){
            let id = parseInt($(this).val());
            let packages = self._state.item.packages.filter(function(pack){
                return pack.id == id;
            });
            if (!packages.length) return;
            let pack = packages[0];

            if (pack){
                let price = '<span class="base">' + ifacade_format_price(pack.price) + '</span> руб.';
                self._elems.$form.find('[data-name="package"] .price').html(price);
            }
        }).trigger('change');
    };

    _bindConfirm = (args) => {
        let self = this;

        let $modal = args.modal;
        if (!$modal.length) return;
        let $form = $modal.find('form');
        if (!$form.length) return;

        let errors = $form.find('.form-field.error').length;
        if (errors) return;

        Request.send({
            path   : '/api/payments/create',
            method : 'POST',
            data   : $form.serialize(),
            done   : function (response) {
                loader.decrease();

                if (response.error) {
                    self._utils.validation.showErrors(response.error);
                    return;
                }

                if(response.payment) {
                    window.location.href = '/profile#payments/' + response.payment.number;
                }
                $modal.trigger('close');
            }
        });
    };

    _bindElements = () => {
        let self = this;

        if (!self._elems.$content.length) self._elems.$content = $('.content');
        if (!self._elems.$content.length) return;

        self._elems.$connect = self._elems.$content.find('.js-profile-tariff-connect');
    };

    _bindConnect = () => {
        let self = this;
        if (!self._elems.$connect.length) return;

        self._elems.$connect.unbind('click').on('click', function(e){
            e.preventDefault();

            self._state.id = parseInt($(this).data('id'));
            self._initModal();
        });
    };

    _bindUI = () => {
        let self = this;
        if (!self._elems.$content.length) return;

        self._bindConnect();
    };

    _list = () => {
        let self = this;

        Request.send({
            path: '/api/pages/' + self._const.entities,
            done: function(response) {
                loader.decrease();
                Utils.scrollToTop();

                self._state.items  = response[self._const.entities];

                let breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Профиль',
                            href  : '#'
                        },
                        {
                            title : self._args.title
                        }
                    ],
                    dropdown : null,
                    activate : null
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._args.page, {
                    breadcrumbs : breadcrumbs,
                    view        : Vars.view.tile,
                    columns     : 3,
                    entity      : self._const.entity,
                    entities    : self._const.entities,
                    actions     : false,
                    group       : false,
                    items       : self._state.items,
                    item_id     : self._const.id,
                    detail      : false,
                    card        : function(entity, item){
                        return Utils.renderProfileTemplate(self._const.entity, {
                            [self._const.entity] : item,
                            mode                 : self._args.page
                        });
                    }
                }));

                if (self._elems.$content.find('.breadcrumbs').length) {
                    self._elems.$content.find('.breadcrumbs').after(
                        Utils.renderProfileTemplate(self._const.entity + '-description')
                    );
                }

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _init = () => {
        let self = this;
        self._bindElements();
        if (!self._elems.$content.length) return;

        if (self._args.page === Vars.page.list) {
            self._list();
        }
        else if (self._args.page == Vars.view.item) {
            self._item();
        }
    };
}

export default Tariff;